export default __webpack_public_path__ + "static/media/rs_raceweek_italia_cochemoto_330x330.603f7d94.webp";